var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        persistent: "",
        width: "700px",
        "max-width": "90vw",
      },
      on: { "click:outside": _vm.closeModal },
    },
    [
      _c(
        "v-card",
        { staticClass: "d-flex flex-column ruleset-shuttle-card" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "main white--text pa-2 d-flex justify-space-between",
            },
            [
              _c("span", [
                _vm._v(" Shuttle Ruleset "),
                _vm.ruleset.rule_display_name
                  ? _c(
                      "span",
                      { staticClass: "text-subtitle-2 font-italic ml-2" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.ruleset.rule_display_name) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "v-icon",
                {
                  attrs: { color: "grey lighten-1" },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("mdi-close")]
              ),
            ],
            1
          ),
          _c(
            "v-toolbar",
            { staticClass: "flex-grow-0", attrs: { flat: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        staticClass: "mt-4",
                        attrs: {
                          label: "Filter",
                          "prepend-inner-icon": "mdi-filter-variant",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tree-wrapper px-4 pb-2" },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-center align-center",
                      staticStyle: { height: "200px" },
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  )
                : _vm.treeItems.length === 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-center align-center grey--text",
                      staticStyle: { height: "200px" },
                    },
                    [_vm._v(" No stores or store groups available ")]
                  )
                : _c("v-treeview", {
                    attrs: {
                      items: _vm.treeItems,
                      search: _vm.search,
                      open: _vm.openIds,
                      "item-key": "id",
                      "item-text": "name",
                      "item-children": "children",
                      selectable: "",
                      "selection-type": "leaf",
                      "open-on-click": "",
                      dense: "",
                    },
                    on: {
                      "update:open": function ($event) {
                        _vm.openIds = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend",
                        fn: function ({ item, open }) {
                          return [
                            item.type === "TPR_STORE_GROUP"
                              ? _c("v-icon", { attrs: { color: "primary" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        open
                                          ? "mdi-folder-open-outline"
                                          : "mdi-folder-outline"
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c(
                                  "v-icon",
                                  { attrs: { color: "grey darken-1" } },
                                  [_vm._v("mdi-store-outline")]
                                ),
                          ]
                        },
                      },
                      {
                        key: "label",
                        fn: function ({ item }) {
                          return [
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            item.type === "TPR_STORE_GROUP" &&
                            item.children &&
                            item.children.length > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "text-caption grey--text ml-2",
                                  },
                                  [
                                    _vm._v(
                                      " (" + _vm._s(item.children.length) + ") "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedLeafIds,
                      callback: function ($$v) {
                        _vm.selectedLeafIds = $$v
                      },
                      expression: "selectedLeafIds",
                    },
                  }),
            ],
            1
          ),
          _c(
            "v-toolbar",
            {
              staticClass: "flex-grow-0 ruleset-shuttle-footer",
              attrs: { flat: "" },
            },
            [
              _vm.targetPartyIds.length > 0
                ? _c(
                    "span",
                    { staticClass: "text-caption grey--text text--darken-2" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.targetPartyIds.length) +
                          " store" +
                          _vm._s(_vm.targetPartyIds.length === 1 ? "" : "s") +
                          " selected "
                      ),
                    ]
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    small: "",
                    disabled: _vm.isShuttling || _vm.expandableIds.length === 0,
                  },
                  on: { click: _vm.expandAll },
                },
                [_vm._v("Expand all")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    small: "",
                    disabled: _vm.isShuttling || _vm.openIds.length === 0,
                  },
                  on: { click: _vm.collapseAll },
                },
                [_vm._v("Collapse all")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.isShuttling },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 green white--text",
                  attrs: {
                    loading: _vm.isShuttling,
                    disabled:
                      _vm.targetPartyIds.length === 0 || _vm.isShuttling,
                  },
                  on: { click: _vm.shuttle },
                },
                [_vm._v("Shuttle")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }